/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { enInfoTap } from "../../../lib/ConstCommand";
import ConstData from "../../../lib/ConstData";   // 20261105 랜딩 HTML 사용 여부 확인용

import WebHiClassInfoHome from "./WebHiClassInfoHome";
import WebHiClassInfoEdutech from "./WebHiClassInfoEdutech";
import WebHiClassInfoContents from "./WebHiClassInfoContents";
import WebHiClassInfoGreenSmartDevice from "./WebHiClassInfoGreenSmartDevice";
import WebHiClassDownload from "./WebHiClassDownload";
import WebHiClassInfoQnA from "./WebHiClassInfoQnA";
import WebHiClassInfoComposition from "./WebHiClassInfoComposition";
import WebHiClassInfoHtml from "./WebHiClassInfoHtml";   // 20261105 정적 HTML 탭 본문

// 20261105 탭별 정적 HTML 파일 이름 (public/landing/pages/{이름}.html)
const LANDING_PAGE_NAME = {
    [enInfoTap.Home]        : "home",
    [enInfoTap.Edutech]     : "edutech",
    [enInfoTap.Contents]    : "contents",
    [enInfoTap.Download]    : "download",
    [enInfoTap.FAQ]         : "faq",
    [enInfoTap.Composition] : "compo",
};

const WebHiClassInfo = ({ currentInfoTap, currentLandingPage, isLoginYn, download_info, handleSelectedFunc, isOriginalOnly }) => {

    // console.log(document.getElementsByClassName("nav-list"));

    // 20261105 로그인 전에는 menu.json 에서 선택한 페이지, 로그인 후(/info)에는 기존 탭에 맞는 페이지
    const landingPageName = (isLoginYn === "N" && currentLandingPage) ? currentLandingPage : LANDING_PAGE_NAME[currentInfoTap];

    // 20261105 USE_LANDING_HTML이 켜져 있으면 정적 HTML로 표시하고, HTML을 못 읽으면 기존 화면(isOriginalOnly)으로 표시
    if (ConstData.USE_LANDING_HTML && !isOriginalOnly && landingPageName) {
        return (
            <WebHiClassInfoHtml
                pageName={landingPageName}
                download_info={download_info}
                handleSelectedFunc={handleSelectedFunc}
                fallback={
                    <WebHiClassInfo
                        currentInfoTap={currentInfoTap}
                        download_info={download_info}
                        handleSelectedFunc={handleSelectedFunc}
                        isOriginalOnly={true}
                    />
                }
            />
        );
    }

    switch (currentInfoTap) {
        case enInfoTap.Home:
            return <WebHiClassInfoHome />;

        case enInfoTap.Edutech:
            return <WebHiClassInfoEdutech />;

        case enInfoTap.Contents:
            return <WebHiClassInfoContents />;

        case enInfoTap.SmartSheet:
            return <WebHiClassInfoGreenSmartDevice />;

        case enInfoTap.Download:
            return <WebHiClassDownload download_info={download_info} handleSelectedFunc={handleSelectedFunc} />;

        case enInfoTap.FAQ:
            return <WebHiClassInfoQnA />;

        case enInfoTap.Composition:
            return <WebHiClassInfoComposition />;

        default:
            return <WebHiClassInfoHome />;
    }
}

export default WebHiClassInfo;